<template>
  <div id="app" class="p-4">
    <form
      @submit.prevent="enviarFormulario"
      class="max-w-lg mx-auto bg-gray-800 p-6 rounded-lg shadow-lg"
    >
      <h2 class="text-2xl font-semibold text-orange-500 mb-4">
        Informacion general
      </h2>

      <div class="mb-4">
        <label class="block text-lg text-gray-300">Cliente</label>
        <input
          v-model="venta.cliente.Nombre"
          type="text"
          placeholder="Nombre del cliente o institucion"
          @input="buscarSugerenciasClientes"
          @blur="ocultarSugerenciasClientesConRetraso"
          class="mt-2 w-full p-3 rounded-md bg-gray-600 text-white border border-gray-500 focus:ring-2 focus:ring-orange-500"
        />
        <!-- Sugerencias de clientes -->
        <ul
          v-if="mostrarSugerenciasClientes"
          class="sugerencias mt-2 list-none p-0 bg-white text-gray-800 border border-gray-300 rounded-md shadow-lg"
        >
          <li
            v-for="sugerencia in sugerenciasClientes"
            :key="sugerencia.Nombre"
            @click="seleccionarSugerenciaClientes(sugerencia)"
            class="px-4 py-2 cursor-pointer hover:bg-orange-200"
          >
            {{ sugerencia.Nombre + ` (${sugerencia.Comentarios}) ` }}
          </li>
        </ul>
      </div>

      <div
        class="flex items-center space-x-2 cursor-pointer"
        @click="toggleAjuste"
      >
        <h2 class="text-2xl font-semibold text-orange-500 mb-4">
          Descuento/Recargo
        </h2>
        <svg
          v-if="!mostrarAjuste"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          class="size-6"
        >
          <path
            fill-rule="evenodd"
            d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 9a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V15a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V9Z"
            clip-rule="evenodd"
          />
        </svg>

        <svg
          v-if="mostrarAjuste"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          class="size-6"
        >
          <path
            fill-rule="evenodd"
            d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z"
            clip-rule="evenodd"
          />
        </svg>
      </div>

      <!-- Contenido del acordeón -->
      <div v-if="mostrarAjuste" class="mb-4">
        <div class="mb-4">
          <label class="block text-lg text-gray-300">Tipo</label>
          <select
            v-model="venta.adicional.tipoAjuste"
            class="mt-2 w-full p-3 rounded-md bg-gray-600 text-white border border-gray-500 focus:ring-2 focus:ring-orange-500"
          >
            <option value="0">Descuento</option>
            <option value="1">Recargo</option>
          </select>
        </div>

        <div class="mb-4">
          <label class="block text-lg text-gray-300">Modo</label>
          <select
            v-model="venta.adicional.modoAjuste"
            class="mt-2 w-full p-3 rounded-md bg-gray-600 text-white border border-gray-500 focus:ring-2 focus:ring-orange-500"
          >
            <option value="0">Porcentaje</option>
            <option value="1">Monto Fijo</option>
          </select>
        </div>

        <div class="mb-4">
          <label class="block text-lg text-gray-300">Valor</label>
          <input
            v-model.number="venta.adicional.valorAjuste"
            type="number"
            placeholder="Ingrese el valor del ajuste"
            class="mt-2 w-full p-3 rounded-md bg-gray-600 text-white border border-gray-500 focus:ring-2 focus:ring-orange-500"
          />
        </div>
      </div>
    </form>
    <!-- Formulario para agregar productos y generar presupuesto -->
    <form
      @submit.prevent="enviarFormulario"
      class="max-w-lg mt-8 mx-auto bg-gray-800 p-6 rounded-lg shadow-lg"
    >
      <h2 class="text-2xl font-semibold text-orange-500 mb-4">
        Agregar Producto
      </h2>
      <div class="mb-4">
        <label class="block text-lg text-gray-300">Nombre del Producto</label>
        <input
          v-model="nuevoProducto.nombre"
          type="text"
          placeholder="Nombre del producto"
          @input="buscarSugerenciasProductos"
          @blur="ocultarSugerenciasProductosConRetraso"
          class="mt-2 w-full p-3 rounded-md bg-gray-600 text-white border border-gray-500 focus:ring-2 focus:ring-orange-500"
        />
        <!-- Sugerencias -->
        <ul
          v-if="mostrarSugerencias"
          class="sugerencias mt-2 list-none p-0 bg-white text-gray-800 border border-gray-300 rounded-md shadow-lg"
        >
          <li
            v-for="sugerencia in sugerencias"
            :key="sugerencia.nombre"
            @click="seleccionarSugerenciaProductos(sugerencia)"
            class="px-4 py-2 cursor-pointer hover:bg-orange-200"
          >
            {{ sugerencia.nombre }} - ${{ sugerencia.precio }}
          </li>
        </ul>
      </div>
      <div class="mb-4">
        <label class="block text-lg text-gray-300">Precio</label>
        <input
          v-model.number="nuevoProducto.precio"
          type="number"
          placeholder="Precio del producto"
          class="mt-2 w-full p-3 rounded-md bg-gray-600 text-white border border-gray-500 focus:ring-2 focus:ring-orange-500"
        />
      </div>
      <div class="mb-6">
        <label class="block text-lg text-gray-300">Cantidad</label>
        <input
          v-model.number="nuevoProducto.cantidad"
          type="number"
          placeholder="Cantidad"
          class="mt-2 w-full p-3 rounded-md bg-gray-600 text-white border border-gray-500 focus:ring-2 focus:ring-orange-500"
        />
      </div>
      <button
        type="button"
        @click="agregarProducto"
        class="w-full py-3 text-lg text-white bg-blue-500 rounded-md hover:bg-blue-600"
      >
        Agregar Producto
      </button>
    </form>

    <!-- Lista de productos agregados -->
    <div class="mt-8 max-w-lg mx-auto bg-gray-800 p-6 rounded-lg shadow-lg">
      <h2 class="text-2xl font-semibold text-orange-500 mb-4">Resumen</h2>
      <ul>
        <li
          v-for="(producto, index) in venta.productos"
          :key="index"
          class="mb-4 p-4 bg-gray-700 rounded-md border border-gray-600 flex justify-between items-center"
        >
          <div>
            <p class="text-white">
              <strong>Nombre:</strong> {{ producto.nombre }}
            </p>
            <p class="text-gray-400">
              <strong>Precio:</strong> ${{ producto.precio }}
            </p>
            <p class="text-gray-400">
              <strong>Cantidad:</strong> {{ producto.cantidad }}
            </p>
          </div>
          <button
            @click="eliminarProducto(index)"
            class="py-2 px-4 text-white bg-red-500 rounded-md hover:bg-red-600"
          >
            Eliminar
          </button>
        </li>
      </ul>
      <p v-if="venta.productos.length > 0" class="text-white text-lg">
        {{
          calcularTotal().subtotal == calcularTotal().total
            ? ""
            : `Subtotal: $${calcularTotal().subtotal}`
        }}
      </p>
      <p v-if="venta.productos.length > 0" class="text-white text-lg">
        {{
          calcularTotal().ajuste === 0
            ? ""
            : calcularTotal().ajuste > 0
            ? `Recargo: $${calcularTotal().ajuste}`
            : `Descuento: $${Math.abs(calcularTotal().ajuste)}`
        }}
      </p>
      <p v-if="venta.productos.length > 0" class="text-white text-lg">
        Total: ${{ calcularTotal().total }}
      </p>
    </div>

    <!-- Botón para generar presupuesto -->
    <div class="mt-6 max-w-lg mx-auto">
      <button
        @click="enviarFormulario"
        class="w-full py-3 text-lg text-white bg-green-500 rounded-md hover:bg-green-600"
      >
        Registrar venta
      </button>
    </div>
  </div>
</template>

<script>
import VentasProvider from "@/helpers/providers/VentasProvider";
import ProductsProvider from "@/helpers/providers/ProductsProvider";
import PresupuestosProvider from "@/helpers/providers/PresupuestosProvider";
import ClientesProvider from "@/helpers/providers/ClientesProvider";

export default {
  data() {
    return {
      mostrarAjuste: false,
      venta: {
        cliente: { ID_CLIENTE: 0, Nombre: "" },
        productos: this.$route.params.productos || [],
        adicional: {
          tipoAjuste: 0, // "descuento" o "recargo"
          modoAjuste: 0, // "porcentaje" o "monto"
          valorAjuste: 0,
        },
      },
      nuevoProducto: {
        nombre: "VARIOS",
        precio: 0,
        cantidad: 1,
      },
      sugerencias: [],
      mostrarSugerencias: false,
      productosMemoria: [],
      clientesMemoria: [],
      sugerenciasClientes: [],
      mostrarSugerenciasClientes: false,
    };
  },

  methods: {
    toggleAjuste() {
      this.mostrarAjuste = !this.mostrarAjuste; // Alterna la visibilidad del ajuste
    },
    calcularTotal() {
      const subtotal = this.venta.productos.reduce(
        (sum, producto) => sum + producto.precio * producto.cantidad,
        0
      );

      let ajuste = 0;
      if (this.venta.adicional.modoAjuste == 0) {
        ajuste = (subtotal * this.venta.adicional.valorAjuste) / 100;
      } else {
        ajuste = this.venta.adicional.valorAjuste;
      }

      if (this.venta.adicional.tipoAjuste == 0) {
        ajuste = -ajuste;
      }

      let total = subtotal + ajuste;
      //let subtotal = 0;
      //let total = 0;
      //let ajuste = 0;

      return { subtotal, total, ajuste };
    },

    async cargarProductos() {
      try {
        this.productosMemoria = await ProductsProvider.getProductos();
      } catch (error) {
        console.error("Error al cargar productos:", error);
      }
    },
    async cargarClientes() {
      try {
        this.clientesMemoria = await ClientesProvider.getClientes();
      } catch (error) {
        console.error("Error al cargar Clientes:", error);
      }
    },
    buscarSugerenciasProductos() {
      const query = this.nuevoProducto.nombre;
      if (query.length < 2) {
        this.sugerencias = [];
        this.mostrarSugerencias = false;
        return;
      }
      this.sugerencias = this.productosMemoria.filter((producto) =>
        producto.nombre.toLowerCase().includes(query.toLowerCase())
      );
      this.mostrarSugerencias = this.sugerencias.length > 0;
    },
    seleccionarSugerenciaProductos(producto) {
      this.nuevoProducto.nombre = producto.nombre;
      this.nuevoProducto.precio = producto.precio;
      this.mostrarSugerencias = false;
    },
    ocultarSugerenciasProductosConRetraso() {
      setTimeout(() => {
        this.mostrarSugerencias = false;
      }, 200);
    },
    buscarSugerenciasClientes() {
      const query = this.venta.cliente.Nombre;
      if (query.length < 2) {
        this.sugerenciasClientes = [];
        this.mostrarSugerenciasClientes = false;
        return;
      }
      this.sugerenciasClientes = this.clientesMemoria.filter((cliente) =>
        cliente.Nombre.toLowerCase().includes(query.toLowerCase())
      );
      // console.log(this.sugerenciasClientes)
      this.mostrarSugerenciasClientes = this.sugerenciasClientes.length > 0;
    },
    seleccionarSugerenciaClientes(cliente) {
      //console.log(cliente)
      this.venta.cliente.Nombre = cliente.Nombre;
      this.venta.cliente.ID_CLIENTE = cliente.ID;
      this.mostrarSugerenciasClientes = false;
    },
    ocultarSugerenciasClientesConRetraso() {
      setTimeout(() => {
        this.mostrarSugerenciasClientes = false;
      }, 200);
    },
    agregarProducto() {
      if (
        this.nuevoProducto.nombre &&
        this.nuevoProducto.precio > 0 &&
        this.nuevoProducto.cantidad > 0
      ) {
        this.venta.productos.push({ ...this.nuevoProducto });
        this.nuevoProducto = { nombre: "", precio: 0, cantidad: 1 };
      } else {
        this.$notiflix.Notify.failure('Por favor, complete los campos correctamente.');
      }
    },
    eliminarProducto(index) {
      this.venta.productos.splice(index, 1);
    },
    async enviarFormulario() {
      try {
        this.$notiflix.Loading.standard();
        const respuesta = await VentasProvider.newVenta(this.venta);
        this.$notiflix.Loading.remove();
        if (respuesta) {
          this.$notiflix.Notify.success(
            "Venta registrada con éxito.",
          );
          this.venta = {
            cliente: { ID_CLIENTE: 0, Nombre: "" },
            productos: [],
            adicional: {
              tipoAjuste: 0,
              modoAjuste: 0,
              valorAjuste: 0,
            },
          };
        } else {
          this.$notiflix.Report.failure(
            "Error al registrar venta",
            "Compruebe los campos e intente nuevamente.",
            "Cerrar"
          );
        }
      } catch (error) {
        this.$notiflix.Report.failure(
            "Error al registrar venta",
            "Compruebe los campos e intente nuevamente.",
            "Cerrar"
          );
      }
    },
  },
  async mounted() {
    this.cargarProductos();
    this.cargarClientes();
    if (this.$route.query.presupuesto != undefined) {
      //console.log(this.$route.query.presupuesto);
      //Aca logica de fetchear presupuesto y cargarlo en el formulario
      this.$notiflix.Loading.standard();
      var presupuesto = await PresupuestosProvider.getPresupuesto(
        this.$route.query.presupuesto
      );
      this.venta.cliente.Nombre = presupuesto.cabecera.CLIENTE;
      console.log(this.clientesMemoria);
      const clienteEncontrado = this.clientesMemoria.find(
        (cliente) => cliente.Nombre === presupuesto.cabecera.CLIENTE
      );
      if (clienteEncontrado) {
        this.venta.cliente.ID_CLIENTE = clienteEncontrado.ID;
      }
      // this.venta.productos = ;
      presupuesto.detalles.forEach((element) => {
        const producto = {
          nombre: element.Producto,
          precio: element.Precio,
          cantidad: element.Cantidad,
        };
        this.venta.productos.push(producto);
      });
      if (presupuesto.adicional != undefined) {
        this.mostrarAjuste = true;
        this.venta.adicional.tipoAjuste = presupuesto.adicional.Tipo;
        this.venta.adicional.modoAjuste = presupuesto.adicional.Modo;
        this.venta.adicional.valorAjuste = presupuesto.adicional.Valor;
      }
      this.$notiflix.Loading.remove();
    }
   
  },
};
</script>
<!-- venta: {
        cliente: { ID_CLIENTE: 0, Nombre: "" },
        productos: this.$route.params.productos || [],
        adicional: {
          tipoAjuste: 0, // "descuento" o "recargo"
          modoAjuste: 0, // "porcentaje" o "monto"
          valorAjuste: 0,
        },
      }, -->
